import { z } from 'zod/v4'

// Schema for linked apps from AppResourceInstance
// Defined in a separate file to avoid circular dependencies between model and field types
export const LinkedAppSchema = z.object({
  id: z.string(),
  appName: z.string(),
  appHandle: z.string(),
  installId: z.string(),
  resourceHandle: z.string(),
  scope: z.enum(['INTERNAL', 'SHARED']),
  iconUrl: z.string().nullable().optional(),
  accentColor: z.string().nullable().optional(),
})

export type LinkedApp = z.infer<typeof LinkedAppSchema>
